export default "__VITE_ASSET__b23acaf5__"